// extracted by mini-css-extract-plugin
module.exports = {"homeContent":"index_homeContent__OPj0R","desc":"index_desc__O5s8m"};